import _itemcollection from "./items_from_sheet.json"

export const itemcollection = _itemcollection as unknown as Item[]

// const itemcollection_: Item[] = [
//   {
//     id: 'can',
//     article_de: 'die',
//     unbest_artikel_de:"eine",
//     name_de: 'Getränkedose',
//     image: 'products_can',
//     correct: ['alu'],
//     correct_text_de:
//       'So und nicht anders .... Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquamv oluptatibus, quod, quae, quia voluptatem quos dolorum natus voluptates repellendus eaque quibusdam doloremque. Quisquam',
//     options: ['rest', 'altglas', 'alu', 'sonderabfall', 'metall', 'special'],
//   },
//   {
//     id: 'medis',
//     article_de: 'das',
//     unbest_artikel_de:"ein",
//     name_de: 'Medikament',
//     image: 'products_mdeis',
//     correct: ['special'],
//     correct_text_de:
//       'So und nicht anders .... Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquamv oluptatibus, quod, quae, quia voluptatem quos dolorum natus voluptates repellendus eaque quibusdam doloremque. Quisquam',
//     options: ['rest', 'plastic', 'sonderabfall', 'special'],
//   },
//   {
//     id: 'plasticbag',
//     article_de: 'das',
//     unbest_artikel_de:"ein",
//     name_de: 'Plasticksäckli',
//     image: 'products_plasticbag',
//     correct: ['plastic'],
//     correct_text_de:
//       'So und nicht anders .... Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquamv oluptatibus, quod, quae, quia voluptatem quos dolorum natus voluptates repellendus eaque quibusdam doloremque. Quisquam',
//     options: ['rest', 'plastic'],
//   },
//   {
//     id: 'coffecapsule',
//     article_de: 'die',
//     unbest_artikel_de:"eine",
//     name_de: 'Kaffeekapsel',
//     image: 'products_coffecapsule',
//     correct: ['special'],
//     correct_text_de:
//       'So und nicht anders .... Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquamv oluptatibus, quod, quae, quia voluptatem quos dolorum natus voluptates repellendus eaque quibusdam doloremque. Quisquam',
//     options: ['rest', 'special', 'alu', ',metall'],
//   },
//   {
//     id: 'grillschale',
//     article_de: 'die',
//     unbest_artikel_de:"eine",
//     name_de: 'Grillschale',
//     image: 'products_grillschale',
//     correct: ['alu'],
//     correct_text_de:
//       'So und nicht anders .... Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquamv oluptatibus, quod, quae, quia voluptatem quos dolorum natus voluptates repellendus eaque quibusdam doloremque. Quisquam',
//       options: ['rest', 'special', 'alu', ',metall'],

//   },
//   {
//     id: 'joghurt',
//     article_de: 'der',
//     unbest_artikel_de:"ein",
//     name_de: 'Joghurtbecher',
//     image: 'products_joghurt',
//     correct: ['separate'],
//     correct_text_de:
//       'So und nicht anders .... Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquamv oluptatibus, quod, quae, quia voluptatem quos dolorum natus voluptates repellendus eaque quibusdam doloremque. Quisquam',
//       options:[ "rest", "alu", "separate", "plastic"]
//   },
//   {
//     id: 'plasticcutlery',
//     article_de: 'das',
//     unbest_artikel_de:"ein",
//     name_de: 'Plastikbesteck',
//     image: 'products_plasticcutlery',
//     correct: ['plastic'],
//     correct_text_de:
//       'So und nicht anderss .... Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquamv oluptatibus, quod, quae, quia voluptatem quos dolorum natus voluptates repellendus eaque quibusdam doloremque. Quisquam',
//       options: ['rest', 'plastic'],

//   },
//   {
//     id: 'tetra',
//     article_de: 'der',
//     unbest_artikel_de:"ein",
//     name_de: 'Getränkekarton',
//     image: 'products_tetra',
//     correct: ['special'],
//     correct_text_de:
//       'So und nicht anders .... Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquamv oluptatibus, quod, quae, quia voluptatem quos dolorum natus voluptates repellendus eaque quibusdam doloremque. Quisquam',
//       options: ["rest", "paper", "karton", "special"],
//   },
//   {
//     id: 'cat',
//     article_de: 'das',
//     unbest_artikel_de:"ein",
//     name_de: 'Katzenstreu',
//     image: 'products_katzenstreu',
//     correct: ['rest'],
//     correct_text_de:
//       'So und nicht anders .... Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquamv oluptatibus, quod, quae, quia voluptatem quos dolorum natus voluptates repellendus eaque quibusdam doloremque. Quisquam',
//       options:["rest", "toilett", "bury"]
//   },
// ]

export const itemmap: { [key: string]: Item } = itemcollection.reduce(
  (acc: any, item) => {
    acc[item.id] = item
    return acc
  },
  {}
)
